import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { fetchAuthSessionWithLogout } from '@/features/auth/lib/authSession';

const rawBaseQuery = fetchBaseQuery({
  baseUrl: import.meta.env.VITE_AWS_API_ENDPOINT,
  prepareHeaders: async (headers) => {
    const accessToken = await fetchAuthSessionWithLogout();
    if (accessToken) {
      headers.set('Authorization', `Bearer ${accessToken.toString()}`);
    }
    headers.set('Content-Type', 'application/json');
    return headers;
  },
});

const baseQueryWithStatus = async (args, api, extraOptions) => {
  const result = await rawBaseQuery(args, api, extraOptions);
  if (result.error) {
    return result;
  }
  const data = result.data;
  if (data?.error || (data?.statusCode != null && data.statusCode !== 200 && data.statusCode !== 201)) {
    return {
      error: {
        status: data?.statusCode || 400,
        data: data?.error || data?.message || data,
      },
    };
  }
  return result;
};

export const baseApi = createApi({
  reducerPath: 'api',
  baseQuery: baseQueryWithStatus,
  tagTypes: ['User', 'Tools', 'Reports', 'Members', 'Templates', 'Substitutes', 'Transactions'],
  endpoints: () => ({}),
});
